import HotelRulesTemplate from "../../../templates/admin/hotelRules";

const HotelRulesScreen = () => {
  return <HotelRulesTemplate />;
};

export default HotelRulesScreen;
